import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gw-findings-not-assigned',
  templateUrl: './findings-not-assigned.component.html',
  styleUrls: ['./findings-not-assigned.component.scss']
})
export class FindingsNotAssignedComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
